import script from "./StoreAdminSlots.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreAdminSlots.vue?vue&type=script&setup=true&lang=js"

import "./StoreAdminSlots.vue?vue&type=style&index=0&id=618cd838&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-618cd838"]])

export default __exports__